// 收款方式枚举
export const PAY_MODE = {
  YEAR: 1, // 年付
  HALF_YEAR: 2, // 半年一付
  WEEK: 3, // 周付
  FULL_MOON: 4, // 月付(满月)
  NATURAL_MONTH: 5, // 月付(自然月)
  DISPOSABLE: 6, // 一次性
  TRIMESTER: 8, // 三月一付
  DAYS_30: 9, // 30天一付
  DAY: 10, // 日付
  STAGES: 11, // 分期
  NATURAL_WEEK: 12, // 自然周
  POSTPAID_ITEM: 101, // 后置费项收款
}
// 收款方式
export const PAY_MODE_TEXT = {
  [PAY_MODE.NATURAL_MONTH]: '月付(自然月)',
  [PAY_MODE.FULL_MOON]: '月付(满月)',
  [PAY_MODE.WEEK]: '周付(满周)',
  [PAY_MODE.NATURAL_WEEK]: '周付(自然周)',
  [PAY_MODE.DAY]: '日付',
}
// 司机合作时可用到的收款方式
export const PAY_MODE_BY_DRIVER_COOPERATION = {
  MONTH: 5,
  WEEK: 12,
  DAY: 10,
}

export const PAY_MODE_BY_DRIVER_COOPERATION_TEXT = {
  [PAY_MODE_BY_DRIVER_COOPERATION.MONTH]: '月结',
  [PAY_MODE_BY_DRIVER_COOPERATION.WEEK]: '周结',
  [PAY_MODE_BY_DRIVER_COOPERATION.DAY]: '日结',
}
// 租赁类别
export const CATEGORY_CODE_MAP = {
  ZU_CHE: 1, // '纯租',
  YI_ZU_DAI_GOU: 2, // '已租代购',
  SI_JI_HE_ZUO_MO_SHI: 4, // '司机合作模式'
}

export const CATEGORY_LIST = {
  [CATEGORY_CODE_MAP.ZU_CHE]: '纯租',
  [CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI]: '司机合作',
  [CATEGORY_CODE_MAP.YI_ZU_DAI_GOU]: '以租代购',
}

// 租赁周期类型
export const RENT_PERIOD_TYPE = {
  DAY: 1, // 日
  WEEK: 2, // 周
  MONTH: 3, // 月
}

// 租赁类型对应的服务端获取费项枚举值的type
export const CATEGORY_FEE_TYPE = {
  [CATEGORY_CODE_MAP.ZU_CHE]: 'orderSignRentFee',
  [CATEGORY_CODE_MAP.YI_ZU_DAI_GOU]: 'orderSignPurchaseFee',
  [CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI]: 'orderSignCooperateFee',
}

// 费项字典
export const FEE_CODE_MAP = {
  ZU_JIN: 1, // 租金
  YA_JIN: 2, // 押金
  GUAN_LI_FEE: 3, // 管理费
  FU_WU_FEE: 4, // 服务费
  WEI_BAO_FEI_YONG: 5, // 维保费用
  CHU_XIAN_FEI_YONG: 6, // 出险费用
  WEI_ZHANG_DAI_BAN: 7, // 违章代办
  YOU_FEE: 8, // 油费
  WEI_YUE_JIN: 9, // 违约金
  CHE_SUN: 10, // 车损
  MIAN_YONG: 11, // 免佣
  YA_JIN_TUI_KUAN: 12, // 押金退款
  DING_JIN: 13, // 定金
  ZHI_NA_JIN: 14, // 滞纳金
  QUAN_KUAN: 15, // 全款
  BAO_ZHENG_JIN: 16, // 保证金
  YUE_GONG: 17, // 月供
  BAO_FEE: 18, // 报废
  SHI_GU_FEE: 19, // 事故费
  SHOU_CHE_FEE: 20, // 收车费
  WEI_ZHANG_FEE: 21, // 违章费
  YAN_BAO_FEE: 22, // 延保费
  CHA_E_FEE: 23, // 差额费
  SHOU_FU_KUAN: 24, // 首付款
  WEI_KUAN: 25, // 尾款
  BAO_XIAN_FEN_QI: 26, // 保险分期
  TONG_XING_ZHENG_FEE: 27, // 通行证费
  BAO_XIAN_SHANG_ZHANG_FEE: 28, // 保险上涨费
  CHE_LIANG_ZHE_JIU_FEE: 29, // 车辆折旧费
  QUE_BAO_YANG: 30, // 缺保养
  ZHENG_JIAN_YAO_SHI: 31, // 证件、钥匙
  TING_CHE_FEE_ETC: 32, // 停车费、ETC
  BU_QI_ZU_JIN: 33, // 补齐租金
  ZU_JIN_TUI_KUAN: 34, // 租金退款
  CHAO_BAO_FEE: 35, // 超保费
  YUN_YING_LIU_SHUI: 36, // 运营流水
  OTHERS: 100, // 其他
}

// 租赁类型的说明内容
export const CATEGORY_CODE_DESCRIPTION = `<span>
纯租：您与司机签订车辆租赁合同，司机根据合同约定按周期支付租金。在此模式下，系统支持支付的费项为：押金、租金、管理费和服务费，日支付金额有上限限制。<br/>
司机合作：您与司机签署合作分佣协议，根据其跑单流水的阶梯进行灵活结算。在此模式下，系统支持对司机的全部跑单流水进行锁定。<br/>
以租代购：您与司机签署租买合同，在满足条件后应将车辆产权转移给司机个人。在该模式下，系统支持支付的费项为：租金、管理费和服务费。
</span>
`

// 订单来源
export const ORDER_SOURCE = {
  ADMIN: 1, // 车务后台,
  E_COMMERCE: 2, // 租赁商城,
}

// 续约时押金平移书评文案
export const TRANSFER_DEPOSIT_TEXT = `<span>
  勾选是：<br/>
  1）押金会在原订单合同截止时将押金平移至新订单<br />
  2）新订单押金应收金额等于原订单应收押金金额<br />
  3）如在平移时押金仍有押金欠款，会在新订单继续要求司机补缴欠款<br />
  勾选否(原订单未收取押金或押金目前有在途单据时不可平移)：<br />
  1）原订单押金不会平移到新订单，需在原订单合同结束时结算并退款给司机<br />
  2）新订单需重新配置并收取押金
</span>`
